import angular from 'angular';
import uiRouter from 'angular-ui-router';
import authComponent from './auth.component';
import authFactory from './auth.factory';
import authInterceptor from './auth.interceptor';

const authModule = angular
  .module('auth', [uiRouter])
  .component('auth', authComponent)
  .config(($stateProvider, $httpProvider) => {
    'ngInject';

    $httpProvider.interceptors.push('AuthInterceptor');
    $stateProvider.state('auth', {
      url: '/acceder',
      component: 'auth',
    });
  })
  .factory('Auth', authFactory)
  .factory('AuthInterceptor', authInterceptor).name;

export default authModule;



// WEBPACK FOOTER //
// ./client/app/components/auth/auth.js